import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { Point } from "appworks/utils/geom/point";
import { TGRSpinResponseSchema } from "integration/schema/tgr-spin-response-schema";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { slotDefinition } from "slotworks/model/slot-definition";
import { TGRInstantWin, TGRInstantWinResult } from "./tgr-instant-win-result";

export class TGRInstantWinResultBuilder implements ResultBuilder {

    public filter(data: any, record?: SpinRecord): boolean {
        if (record.grid && record.grid[0] && record.grid[0][0] && data.instantWins?.length > 0) {
            return true;
        }
        return false;
    }

    public build(record: SpinRecord, data: any, gamevyResponse?: TGRSpinResponseSchema): Result[] {
        const results: Result[] = [];

        const instantWins = [];
        let collectedSymbolPosition: Point;
        let qhIndex: number = 0;
        let cashWon: number = 0;
        record.grid.forEach((colSyms: string[], x: number) => {
            for (let y: number = 0; y < slotDefinition.matrixGrid[x]; y++) {
                if (colSyms[y] === "QH") {
                    const instantWinResponse = data.instantWins[qhIndex++];
                    const instantWin: TGRInstantWin = {
                        cashWon: instantWinResponse.CASH,
                        showingAmount: instantWinResponse.showingAmount,
                        n: instantWinResponse.n,
                        gridPosition: new Point(x, y)
                    } as TGRInstantWin;
                    instantWins.push(instantWin);
                    cashWon += instantWinResponse.CASH;
                } else if (colSyms[y] === "C") {
                    collectedSymbolPosition = new Point(x, y);
                }
            }
        });

        if (instantWins) {
            const instantWinResult: TGRInstantWinResult = new TGRInstantWinResult();
            instantWinResult.cashWon = cashWon;
            instantWinResult.instantWins = instantWins;
            instantWinResult.collectSymbolPosition = collectedSymbolPosition;
            results.push(instantWinResult);
        }

        return results;
    }
}

export const tgrInstantWinResultBuilder = new TGRInstantWinResultBuilder();
